import { createCoreMethod } from '../../utils/createCoreMethod';

export const getSelectedNode = createCoreMethod(
  'getSelectedNode',
  async (): Promise<Pick<SceneNode, 'id' | 'name' | 'type'> | null> => {
    const selection = figma.currentPage.selection[0];

    if (!selection) return null;

    return {
      id: selection.id,
      name: selection.name,
      type: selection.type,
    };
  }
);
